const breadCrumb = "Exames - Relatórios de Pendências do Exame";

const routes = [
  {
    path: "/relatorios-pendencias-exames/gerar",
    name: "relatorios-pendencias-exames-gerar",
    meta: {
      allowedPermissions: ["exame_amparo_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarRelatorioPendenciasExame/GerarRelatorioPendenciasExame.vue"
      ),
  },
];

export default routes;
